import React from 'react';
import { Box, Grid, Stack, Typography } from '@mui/material';
import useResponsive from 'src/hooks/useResponsive';
import { LoginForm } from 'src/containers/Forms';

const Login = () => {
  const isDesktop = useResponsive('up', 'lg');

  return (
    <Grid container display="flex" flexDirection="row" justifyContent="center" alignItems="center">
      <Grid item xs={6}>
        <Stack
          spacing={3}
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          sx={{ height: '100vh' }}
        >
          <Box sx={{ mr: isDesktop ? '260px' : 'auto' }}>
            <Typography sx={{ fontSize: '5rem' }} fontWeight={700}>
              ورود
            </Typography>

            <Typography variant="body2">لطفا نام کاربری و رمز عبور خود را وارد کنید</Typography>
          </Box>

          <LoginForm />

          {/* <Typography>{`© تمامی حقوق این سایت متعلق به `}</Typography> */}
        </Stack>
      </Grid>

      {isDesktop && (
        <Grid
          item
          xs={6}
          sx={{
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Box sx={{ width: 520 }}>
            <img src="/images/login-background.jpg" alt="login-background" style={{ borderRadius: '16px' }} />
          </Box>
        </Grid>
      )}
    </Grid>
  );
};

export default Login;
